import React, { Component } from 'react';
import { inject } from 'mobx-react';

import ArticleCompletedList from './ArticleCompletedList';
import ArticleDrawer from './ArticleDrawer';

import ArticleCompletedListStore from '../stores/ArticleCompletedListStore';
import ArticleStore from '../stores/ArticleStore';
import FileStore from '../stores/FileStore';
import MetadataStore from '../stores/MetadataStore';
import PeopleStore from '../stores/PeopleStore';
import PeopleListStore from '../stores/PeopleListStore';

@inject("appStore")
class ArticleCompletedUI extends Component {

    constructor(props) {
        super(props);
        this.articleCompletedListStore = new ArticleCompletedListStore({ apiProxy: props.appStore.apiProxy });
    }

    render() {
        const fileStore = new FileStore({ apiProxy: this.props.appStore.apiProxy });

        const peopleListStore = new PeopleListStore({ apiProxy: this.props.appStore.apiProxy });
        const peopleStore = new PeopleStore({
            apiProxy: this.props.appStore.apiProxy,
            peopleListStore: peopleListStore
        });

        const metadataStore = new MetadataStore({ apiProxy: this.props.appStore.apiProxy });
        
        const articleStore = new ArticleStore({ 
            apiProxy: this.props.appStore.apiProxy,
            fileStore: fileStore,
            peopleStore: peopleStore,
            peopleListStore: peopleListStore,
            metadataStore: metadataStore, 
            appStore: this.props.appStore,
            articleCompletedListStore: this.articleCompletedListStore });

        return (
            <div>
                <ArticleCompletedList articleCompletedListStore={this.articleCompletedListStore} articleStore={articleStore}/>
                <ArticleDrawer articleStore={articleStore}/>
            </div>
        )
    }

}
export default ArticleCompletedUI;
